import { StepEnum } from '../../../../../components-library/checkout/CheckoutSteps';

export default {
  steps: {
    [StepEnum.OrderConfirmation]: 'Przegląd zamówienia',
    [StepEnum.OrderPayment]: 'Płatność',
  },
};
